import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/global.css'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
Vue.use( VueClipboard )

// 配置请求的根路径
axios.defaults.baseURL = 'https://sta.adsabghhg23.xyz/'
// axios.defaults.baseURL = 'http://127.0.0.1:7777'
Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')